import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import classnames from 'classnames';
import { whitelistStyles } from "../../core/hoc";
import SaveButtons from "../save-buttons";
import TabMenu from "../../core/tab-menu";
import Layout from "../../core/layout";
import { positions, colors, buttonStates } from "../../../enums";
var Toolbar = createComponent({
  displayName: 'Toolbar',
  propTypes: {
    isContentDivided: PropTypes.bool,
    isDisabled: PropTypes.bool,
    header: PropTypes.element,
    // <Header />
    children: PropTypes.node,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onApply: PropTypes.func,
    hasBorder: PropTypes.bool,
    areSaveButtonsDivided: PropTypes.bool,
    headerAlignment: PropTypes.oneOf([positions.LEFT, positions.CENTER]),
    tabMenu: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({
      items: PropTypes.array,
      onClick: PropTypes.func,
      activeValue: PropTypes.bool
    })]),
    tooltips: PropTypes.shape({
      save: PropTypes.string,
      cancel: PropTypes.string,
      apply: PropTypes.string
    }),
    tooltipPositions: PropTypes.shape({
      save: PropTypes.oneOf(positions.ALL),
      cancel: PropTypes.oneOf(positions.ALL),
      apply: PropTypes.oneOf(positions.ALL)
    }),
    primaryButtonColor: PropTypes.oneOf(_.without(colors.CORE, colors.ERROR, colors.WARNING)),
    secondaryButtonColor: PropTypes.oneOf(_.without(colors.CORE, colors.ERROR, colors.WARNING)),
    saveAnimationActions: PropTypes.oneOfType([PropTypes.shape(actionShape), PropTypes.arrayOf(PropTypes.shape(actionShape))]),
    applyAnimationActions: PropTypes.oneOfType([PropTypes.shape(actionShape), PropTypes.arrayOf(PropTypes.shape(actionShape))])
  },
  defaultProps: {
    isContentDivided: false,
    isDisabled: false,
    header: undefined,
    onSave: undefined,
    onCancel: undefined,
    children: null,
    onApply: undefined,
    hasBorder: false,
    areSaveButtonsDivided: false,
    tabMenu: undefined,
    headerAlignment: positions.LEFT,
    tooltips: {
      save: '',
      cancel: '',
      apply: ''
    },
    tooltipPositions: {
      save: positions.TOP,
      cancel: positions.TOP,
      apply: positions.TOP
    },
    primaryButtonColor: undefined,
    secondaryButtonColor: undefined,
    saveAnimationActions: undefined,
    applyAnimationActions: undefined
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(props) {
    var _classnames;

    var wrapperClassnames = classnames('ck', 'toolbar', {
      bordered: props.hasBorder,
      inverted: props.isInverted
    }); //set header - has to be a React valid component ? - can't it be a simple string or object and build the rest?

    var header = /*#__PURE__*/React.isValidElement(props.header) ? /*#__PURE__*/React.createElement("div", {
      className: classnames('toolbar-header__content', {
        divided: props.isContentDivided
      })
    }, props.header) : null; //set tabmenu

    var _tabMenu;

    if ( /*#__PURE__*/React.isValidElement(props.tabMenu)) {
      _tabMenu = props.tabMenu;
    } else {
      _tabMenu = props.tabMenu ? /*#__PURE__*/React.createElement(TabMenu, {
        items: props.tabMenu.items ? props.tabMenu.items : [],
        activeValue: props.tabMenu.activeValue,
        "float": positions.LEFT,
        onItemClick: props.tabMenu.onClick,
        isFluid: true,
        isVertical: false
      }) : null;
    } //set saveButtons


    var saveButtons = /*#__PURE__*/React.createElement("div", {
      className: classnames('toolbar-save-buttons', {
        divided: props.areSaveButtonsDivided
      })
    }, /*#__PURE__*/React.createElement(SaveButtons, {
      primaryColor: props.primaryButtonColor,
      secondaryColor: props.secondaryButtonColor,
      onApply: props.onApply,
      onSave: props.onSave,
      onCancel: props.onCancel,
      isDisabled: props.isDisabled,
      tooltips: props.tooltips,
      tooltipPositions: props.tooltipPositions,
      saveAnimationActions: props.saveAnimationActions,
      applyAnimationActions: props.applyAnimationActions,
      isFluid: true
    }));
    return /*#__PURE__*/React.createElement("div", {
      className: wrapperClassnames,
      style: props.style
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames('toolbar-header', (_classnames = {}, _classnames['with-menu'] = !!_tabMenu, _classnames))
    }, /*#__PURE__*/React.createElement(Layout, {
      padding: {
        vertical: null,
        horizontal: null
      },
      isFluidHeight: true,
      columnStyles: {
        verticalAlign: positions.alignColumns.FLEX
      }
    }, props.headerAlignment === positions.LEFT ? [header ? /*#__PURE__*/React.createElement(Layout.Row, {
      key: "0"
    }, /*#__PURE__*/React.createElement(Layout.Column, {
      verticalAlign: positions.verticalAlign.MIDDLE,
      style: {
        padding: '0 10px 0 10px'
      }
    }, header)) : null, _tabMenu ? /*#__PURE__*/React.createElement(Layout.Row, {
      key: "1"
    }, /*#__PURE__*/React.createElement(Layout.Column, {
      style: {
        padding: '0 10px 0 10px'
      }
    }, _tabMenu)) : null] : null, props.headerAlignment === positions.CENTER ? /*#__PURE__*/React.createElement(Layout.Row, null, _tabMenu ? /*#__PURE__*/React.createElement(Layout.Column, {
      style: {
        padding: '0 10px 0 10px'
      }
    }, _tabMenu) : null, header ? /*#__PURE__*/React.createElement(Layout.Column, {
      verticalAlign: positions.alignColumns.MIDDLE,
      style: {
        padding: '0 10px 0 10px'
      }
    }, header) : null) : null)), /*#__PURE__*/React.createElement("div", {
      className: "toolbar-content"
    }, props.children, saveButtons));
  }
});
var actionShape = {
  start: PropTypes.func,
  success: PropTypes.func,
  failure: PropTypes.func
};
export default whitelistStyles()(Toolbar);
//# sourceMappingURL=toolbar.js.map